/**
 * Main HRIS / startups app (was "vendors" in older naming).
 * Override with REACT_APP_STARTUPS_URL if needed (no trailing slash).
 */
export const startupsAppBaseUrl = (process.env.REACT_APP_STARTUPS_URL || "https://app.techcore.io").replace(
	/\/$/,
	""
)

/**
 * Talents web app origin (no trailing slash).
 * QA default; override per environment with REACT_APP_TALENTS_URL (e.g. production URL).
 */
export const talentsAppBaseUrl = (process.env.REACT_APP_TALENTS_URL || "https://talents.techcore.io").replace(
	/\/$/,
	""
)

export const talentsSignupUrl = `${talentsAppBaseUrl}/signup`

/** Talents app login; set REACT_APP_TALENTS_SIGNIN_URL for a full URL override */
export const talentsSignInUrl = (process.env.REACT_APP_TALENTS_SIGNIN_URL || `${talentsAppBaseUrl}/login`).replace(
	/\/$/,
	""
)

/** Startups audience signup on the configured domain */
export const startupsSignupUrl = `${startupsAppBaseUrl}/sign-up/startups`

export const supportMailtoUrl = "mailto:support@techcore.io"

/** Sales CTA — subject helps some clients open the compose window reliably */
export const salesMailtoUrl = "mailto:support@techcore.io?subject=Sales%20inquiry"

/** Sign-in / sign-up targets for the startups (HRIS) product */
export const links = {
	startups: `${startupsAppBaseUrl}/`,
	startupsSignUp: startupsSignupUrl,
}
